import { h } from "preact";

import IconProps from "./IconProps";

function IconSlimArrowRight({ color, width, height, class: cssClass }: IconProps) {
    return (
        <svg class={cssClass} width={width} height={height} viewBox="0 0 11 9">
            <g fill="none" fill-rule="evenodd">
                <g fill={color} fill-rule="nonzero">
                    <path d="M112.477 14c.208 0 .423-.092.61-.27l3.647-3.585c.165-.163.266-.404.266-.645 0-.234-.1-.475-.266-.638l-3.647-3.586c-.187-.184-.402-.276-.61-.276-.517 0-.87.354-.87.822 0 .262.116.46.28.624l1.142 1.134 1.25 1.055H106.91c-.545 0-.911.348-.911.865s.366.872.912.872h7.367l-1.25 1.056-1.141 1.133c-.165.156-.28.362-.28.617 0 .468.352.822.869.822z" transform="translate(-1139 -265) translate(640 192) translate(0 56) translate(393 12)"/>
                </g>
            </g>
        </svg>
    );
}

IconSlimArrowRight.defaultProps = {
    color: "var(--cornflower-blue)",
    width: 11,
    height: 9
};

export default IconSlimArrowRight;
